import i18next from 'i18next'
import { declensionByNum } from 'www/utils'
import getUserLanguage from 'src/utils/getUserLanguage'
import { YEAR_CASES } from 'www/constants/wordCases'

const userLanguage = getUserLanguage()

function getAgeLimitCaseText(limit) {
  const ageLimitCase = declensionByNum(limit, YEAR_CASES.genitive)

  return `\u00A0${limit}\u00A0${i18next.t(ageLimitCase, { ns: userLanguage })}`
}

function getAgesText({ min, max } = {}) {
  if (!min && !max) {
    return ''
  }

  const ageLimitsStrings = []

  if (min) {
    ageLimitsStrings.push(`${i18next.t('от', { ns: userLanguage })}${getAgeLimitCaseText(min)}`)
  }

  if (max) {
    ageLimitsStrings.push(`${i18next.t('до', { ns: userLanguage })}${getAgeLimitCaseText(max)}`)
  }

  return ageLimitsStrings.join(' ')
}

export default getAgesText
